const {getCookie, setCookie} = require("./_APPLICATION");
module.exports  =
{

    buyNodes: require('./Home/buyNodes'),

    buyPods: require('./Home/buyPods'),

    buyBrackets: require('./Home/buyBrackets'),

    nodeSummary: require('./FibreNode/order'),

    guarantee: require('./Home/guarantee'),

    broadband: {

        _init: function() {

           APPLICATION.Global.jscounter();

            // Counter replay button
            $('.dial-comparison__replay button').click(function() {

               APPLICATION.Global.jscounter();

            })

            $('.package, .package-item__button, .package-item button').on('click', function(e){

                if ($(e.target).is("sup")) {
                    return false
                }

                if ($(e.target).attr('data-toggle') == "tooltip") {
                    return false;
                }

                APPLICATION.Home.selectPackage($(this));

                return false;

            });

        },

    },

    selectPackage: function (elm) {

        var $this = elm;

        if (elm.hasClass('voice-package'))
        {
            return
        }
        $('.package.active').removeClass('active');
        $this.addClass('active');
        $('input[name="package"]').val( $this.attr('data-id') );
        $('#choose-package').removeAttr('disabled');
        // now submit the form
        $('#choose-package-form').submit();

    },

    home:  {

        _init: function() {

            window.onload = () => {
                if(!APPLICATION._APPLICATION.getCookie('vonage_modal_seen') && $('#vonage-hp').length > 0) {
                    setTimeout(() => {
                        $('#vonage-hp').modal('show')
                        APPLICATION._APPLICATION.setCookie('vonage_modal_seen', 1, 1, true)
                    }, 2000)
                }
            }

            $('#wifi-guarantee-home-terms').on('click', () => {
                $('#wifi-guarantee-home-terms-modal').modal('show')
            })

        }

    },

}
